<script>
import formDialogCreate from '@/components/iglobalwin/formDialog';
import formPanelCreate from '@/components/iglobalwin/form-warps/dialog-form-panel/dialog-form-panel.js';
// import { validRequired } from '@/common/elementValid.js';
import googleads from '@/backend/services/googleAds/googleAds.js';

import keywordFormList from './keywordFormList.vue';

function getFormData(_obj, vm) {
	let { attributes } = vm;
	let { list } = attributes;
	return {
		list: {
			formType: keywordFormList,
			value: list || [],
			column: [
				{
					label: '搜索关键词',
					type: 'inputBox',
					bind: 'searchTermName',
				},
				{
					label: '最终到达网址（可选）',
					type: 'inputBox',
					bind: 'finalUrl',
				},
				{
					label: '最高每次点击费用（可选）',
					type: 'inputNumBox',
					min: 0,
					bind: 'cpcBidMicros',
				},
				{
					label: '广告系列',
					type: 'tooltip',
					bind: 'campaignName',
				},
				{
					label: '广告组',
					type: 'tooltip',
					bind: 'adGroupName',
				},
			],
		},
	};
}

async function submit(data) {
	let { attributes } = this;
	let { serviceId } = attributes;
	try {
		await googleads.addSearchKeyword(data, serviceId);
		this.$message.success('添加成功');
		this.$emit('confirm');
	} catch (error) {
		this.$emit('cancel');
	}
}

function cancel(self) {
	self.$emit('cancel');
}

function onShowLoad(props) {
	return props || {};
}

const componentForm = formPanelCreate(
	{
		getFormData,
		submit,
		cancel,
	},
	{
		subButton: '确认添加',
		labelPosition: 'top',
	}
);

export default formDialogCreate({
	name: 'addKeywordFormDialog',
	onShowLoad,
	componentForm,
});
</script>
